import React from "react";

import FAQPage from "../routes/faq-page";

const FAQTemplate = (props) => <FAQPage {...props} />;

export default FAQTemplate;
